var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.remains > 0
    ? _c("div", { staticClass: "show-more" }, [
        _vm.remains > 0 && !_vm.showAll
          ? _c(
              "a",
              {
                staticClass: "py-2 default-bold text-primary",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    return _vm.show()
                  }
                }
              },
              [_vm._v("vedi altre " + _vm._s(_vm.remains) + " alternative")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showAll
          ? _c(
              "a",
              {
                staticClass: "py-2 default-bold text-primary",
                attrs: { href: "javascript:void(0)" },
                on: {
                  click: function($event) {
                    return _vm.hide()
                  }
                }
              },
              [_vm._v("vedi solo i risultati principali")]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c25f0d48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c25f0d48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/ShowMore.vue
// module id = null
// module chunks = 